module.exports = __webpack_public_path__ + "images/avatars/female/4.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/avatars/female/4.png
// module id = rkOV
// module chunks = 55